import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { UserCredentialsStore } from '../../user-credentials-store.service';
import { PageTitleComponent } from '../../../page-title/page-title.component';
import { AsyncPipe } from '@angular/common';
import { LoginFormComponent } from '../login-form/login-form.component';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PageTitleComponent, RouterLink, LoginFormComponent, AsyncPipe],
})
export class LoginComponent implements OnInit {
  userCredentials$ = this.userCredentialsStore.userCredentials$;

  constructor(
    private userCredentialsStore: UserCredentialsStore,
    private router: Router,
  ) {}

  ngOnInit() {}

  onLoginResult(success: boolean) {
    if (!success) {
      this.router.navigate(['/']);
    }
  }
}
